import React from 'react';
import { BackupConfigProps } from './types';

interface NFSConfigFormProps {
  config: BackupConfigProps['config'];
  onConfigChange: BackupConfigProps['onConfigChange'];
}

const NFSConfigForm: React.FC<NFSConfigFormProps> = ({ config, onConfigChange }) => {
  const updateNFSConfig = (field: string, value: string | number) => {
    onConfigChange({
      ...config,
      nfs: { ...(config.nfs || {}), [field]: value },
    });
  };

  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Server (IP or Hostname)
        </label>
        <input
          type="text"
          value={config.nfs?.server || ''}
          onChange={(e) => updateNFSConfig('server', e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Path
        </label>
        <input
          type="text"
          value={config.nfs?.path || ''}
          onChange={(e) => updateNFSConfig('path', e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Port
        </label>
        <input
          type="number"
          value={config.nfs?.port || 2049}
          onChange={(e) => updateNFSConfig('port', parseInt(e.target.value || '2049', 10))}
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Username (optional)
        </label>
        <input
          type="text"
          value={config.nfs?.username || ''}
          onChange={(e) => updateNFSConfig('username', e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Password (optional)
        </label>
        <input
          type="password"
          value={config.nfs?.password || ''}
          onChange={(e) => updateNFSConfig('password', e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          SSH Private Key (optional)
        </label>
        <textarea
          value={config.nfs?.sshKey || ''}
          onChange={(e) => updateNFSConfig('sshKey', e.target.value)}
          rows={4}
          placeholder="Paste your private key contents"
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
    </div>
  );
};

export default NFSConfigForm;